import { CommandInput } from "cmdk";
import { twMerge } from "tailwind-merge";

import { closeCommandPalette } from "../../commands";

type Props = {
  searchValue: string;
  onSearchValueChange: (query: string) => void;
  onClear: () => void;
};

export const CommandPaletteSearch = ({
  searchValue,
  onSearchValueChange,
  onClear,
}: Props) => {
  const clearIsDisabled = searchValue.length === 0;

  return (
    <div
      className="plh-flex plh-w-full plh-gap-4 plh-border-b plh-border-b-grey-6 plh-bg-white plh-p-4"
      data-testid="command-palette-search"
    >
      <div className="plh-flex plh-flex-grow plh-items-center plh-justify-between plh-rounded-[5px] plh-px-3 plh-py-[9px] plh-text-grey-5 plh-outline plh-outline-1 plh-outline-grey-5 focus-within:plh-outline-2 focus-within:plh-outline-brand-blue-4">
        <i className="bx bx-search plh-text-[20px]"></i>
        <CommandInput
          className="plh-w-full plh-pl-2 plh-font-roboto plh-text-body plh-text-grey-10 plh-outline-none placeholder:plh-text-grey-5"
          value={searchValue}
          onValueChange={onSearchValueChange}
          placeholder="Search PennyLane.ai..."
          data-testid="command-palette-input"
        />
        <button
          aria-label="Clear search"
          className={twMerge(
            "plh-flex plh-items-center plh-justify-center",
            clearIsDisabled ? "plh-cursor-not-allowed" : "",
          )}
          onClick={onClear}
          disabled={clearIsDisabled}
          data-testid="command-palette-clear"
        >
          <i className="bx bx-x plh-text-[20px] plh-text-grey-5"></i>
        </button>
      </div>
      <button
        type="button"
        className="plh-px-[9px] plh-font-roboto plh-text-footnote plh-text-brand-blue-4 focus-visible:plh-outline-2 focus-visible:plh-outline-[#015FB7] md:plh-hidden"
        onClick={closeCommandPalette}
        data-testid="command-palette-cancel"
      >
        Cancel
      </button>
    </div>
  );
};
